const MerchantInfoIcon = () => {
	return (
		<svg
			width="36"
			height="32"
			viewBox="0 0 36 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M28.5 31.5V26.25H23.25V24.5H28.5V19.25H30.25V24.5H35.5V26.25H30.25V31.5H28.5ZM2.6525 27.125V16.625H0.5V14.875L2.5195 6.125H26.4805L28.5 14.875V16.625H26.3475V22.3475H24.5975V16.625H16.6525V27.125H2.6525ZM4.4025 25.375H14.9025V16.625H4.4025V25.375ZM2.5195 2.625V0.875H26.4805V2.625H2.5195ZM2.271 14.875H26.7325L25.1085 7.875H3.8915L2.271 14.875Z"
				fill="black"
			/>
		</svg>
	);
};

const MerchantEditIcon = () => {
	return (
		<svg
			width="20"
			height="19"
			viewBox="0 0 20 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.99997 18H19M1 18H2.67454C3.16372 18 3.40832 18 3.63849 17.9447C3.84256 17.8957 4.03765 17.8149 4.2166 17.7053C4.41843 17.5816 4.59138 17.4086 4.93729 17.0627L17.5 4.49998C18.3285 3.67156 18.3285 2.32841 17.5 1.49998C16.6716 0.671555 15.3285 0.671556 14.5 1.49998L1.93726 14.0627C1.59136 14.4086 1.4184 14.5816 1.29472 14.7834C1.18506 14.9624 1.10425 15.1574 1.05526 15.3615C1 15.5917 1 15.8363 1 16.3255V18Z"
				stroke="#4B5563"
			/>
		</svg>
	);
};

const PlanDetailIcon = () => {
	return (
		<svg
			width="35"
			height="31"
			viewBox="0 0 35 35"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.271 13.2292H33.7293M1.271 13.2292V32.0209C1.271 32.474 1.45098 32.9085 1.77136 33.2288C2.09173 33.5492 2.52625 33.7292 2.97933 33.7292H32.021C32.4741 33.7292 32.9086 33.5492 33.229 33.2288C33.5493 32.9085 33.7293 32.474 33.7293 32.0209V13.2292M1.271 13.2292V5.54171C1.271 5.08863 1.45098 4.65411 1.77136 4.33373C2.09173 4.01336 2.52625 3.83337 2.97933 3.83337H32.021C32.4741 3.83337 32.9086 4.01336 33.229 4.33373C33.5493 4.65411 33.7293 5.08863 33.7293 5.54171V13.2292"
				stroke="black"
			/>
			<path d="M10.667 23.4792L15.792 28.6042L26.042 18.3542" stroke="black" />
			<path
				d="M10.667 1.27087V8.10421M24.3337 1.27087V8.10421"
				stroke="black"
			/>
		</svg>
	);
};

const CircleTickIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.8146 1.31217C16.0974 0.972746 16.0516 0.468294 15.7121 0.185443C15.3727 -0.0974082 14.8683 -0.051549 14.5854 0.287873L7.21265 9.1352L4.62469 5.90026C4.34869 5.55525 3.84525 5.49932 3.50024 5.77533C3.15523 6.05133 3.0993 6.55477 3.3753 6.89978L6.5753 10.8998L7.18735 11.6648L7.81458 10.9122L15.8146 1.31217ZM8 2.00557e-05C9.41552 2.00557e-05 10.7452 0.367658 11.8987 1.01266L10.8518 2.26894C9.99311 1.84083 9.02468 1.60002 8 1.60002C4.46538 1.60002 1.6 4.4654 1.6 8.00002C1.6 11.5346 4.46538 14.4 8 14.4C11.5346 14.4 14.4 11.5346 14.4 8.00002C14.4 7.27284 14.2787 6.57399 14.0553 5.92259L15.2123 4.53417C15.7171 5.58277 16 6.75836 16 8.00002C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8.00002C0 3.58174 3.58172 2.00557e-05 8 2.00557e-05Z"
				fill="#A6A1A1"
			/>
		</svg>
	);
};

function DangerIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="h-12 w-12"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
			/>
		</svg>
	);
}

export {
	CircleTickIcon,
	DangerIcon,
	MerchantEditIcon,
	MerchantInfoIcon,
	PlanDetailIcon,
};
